module.exports = __webpack_public_path__ + "img/habitation.ca1a8159.jpg";